import React, { useState } from 'react';
import { FlexRow, TableDataState, usePaginatedQueryV8 } from 'motion-components';
import { Card } from 'react-bootstrap';
import { useRootStore } from 'store';
import { useHandleError } from 'shared-pages/services';
import { gqlGetCntItems } from '../graphql';
import { buildWhereFromFilterValues, Filters } from './filters';
import { DataGrid } from './grid';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';

/** Κατάλογος ειδών εισφοράς. Τα πεδία δεν επεξεργάζονται από εδώ. */
export const CntItemsGridPage = observer(() => {
  const { appStore, tableStore } = useRootStore();
  const { handleGraphqlError } = useHandleError('CntItemsGridPage');
  const location = useLocation<any>();
  const history = useHistory();
  const [selected, setSelected] = useState<any>(null);
  const { t } = useTranslation();

  const initOrderBy = 'code ASC';
  const query = usePaginatedQueryV8(
    gqlGetCntItems,
    buildWhereFromFilterValues,
    location.state?.order ?? initOrderBy,
    appStore,
    true,
    { isActive: true },
  );
  const {
    loading,
    data,
    dataCount,
    error,
    initPageIndex,
    filtersChanged,
    gridPageChanged,
    queryState,
    queryParams,
    setQueryParams,
  } = query;

  if (error) {
    handleGraphqlError('query-get', error);
    return <h3 className="text-center">{error.message}</h3>;
  }

  return (
    <Card className="shadow">
      <Card.Header>
        <FlexRow>
          <Card.Title className="m-0">{t('Είδη Εισφορών')}</Card.Title>
        </FlexRow>
      </Card.Header>
      <Card.Body className="nopadding">
        <Filters
          onChange={filtersChanged}
          initialValues={queryState?.filterValues ?? {}}
          disable={tableStore.state !== TableDataState.browse}
        />
        <DataGrid
          loading={loading}
          data={data}
          dataCount={dataCount}
          initPageIndex={initPageIndex}
          onPageChange={gridPageChanged}
          initOrderBy={queryParams?.order ?? initOrderBy}
          onOrderChange={(orderBy) => {
            setQueryParams({ ...queryParams, order: orderBy });
            history.replace({
              pathname: location.pathname,
              state: {
                ...location.state,
                order: orderBy,
              },
            });
          }}
          selected={selected}
          setSelected={setSelected}
        />
      </Card.Body>
    </Card>
  );
});
